import { DisjunctiveClause } from "./criterion";

export type JsonValue =
  | string
  | number
  | boolean
  | null
  | JsonValue[]
  | { [key: string]: JsonValue };

export const AccessRequestStatus = {
  PENDING: "pending",
  IN_REVIEW: "in_review",
  EXPORT_PROCESSING: "export_processing",
  EXPORT_SUCCESSFUL: "export_successful",
  EXPORT_FAILED: "export_failed",
  APPROVED: "approved",
  DENIED: "denied",
  CANCELLED: "cancelled",
} as const;
export type AccessRequestStatus = (typeof AccessRequestStatus)[keyof typeof AccessRequestStatus];

export interface MinimalAccessRequestCriteria {
  id: string;
  description: string;
  participant_count: number;
  content: DisjunctiveClause[];
}

export interface CohortAccessRequest {
  id: string;
  created_by: string;
  updated_by: string | null;
  cohort_name: string;
  cohort_description: string;
  participant_count: number;
  criteria: MinimalAccessRequestCriteria[];
  parent_dataset_id: string;
  child_dataset_id: string | null;
  intended_use: string;
  status: AccessRequestStatus;
  status_reason: string | null;
  custom_fields: Record<string, JsonValue> | null;
  custom_fields_json_schema: Record<string, JsonValue> | null;
  created_at: string;
  updated_at: string;
}

export interface PaginatedAccessRequests {
  items: CohortAccessRequest[];
  total: number;
  limit: number;
  offset: number;
}
